import { useConfig } from '../../../ConfigContext';

const GapControl = () => {
  const {
    selectedMultipleZoomIndex,
    croppers,
    multipleGap,
    setMultipleGap,
    handleZoomPlus,
    handleZoomMinus,
  } = useConfig();

  return (
    <div>
      <div className="w-full flex items-center zooming">
        <label htmlFor="zoom" className="custom-label flex-1">
          Mezery:
        </label>
        <button onClick={() => handleZoomMinus('gap')}>-</button>
        <input
          id="zoom"
          type="range"
          min="0.1"
          max="30"
          step="0.01"
          value={multipleGap}
          onChange={(e) => setMultipleGap(parseFloat(e.target.value))}
          className="w-full flex-1 w-[50%]"
          style={{
            background: '#874fb7',
            color: '#874fb7',
          }}
        />
        <button onClick={() => handleZoomPlus('gap')}>+</button>
        <div className="text-sm text-gray-500 mt-1 items-center flex-1">
          velikost: <span className="font-semibold">{multipleGap}px</span>
        </div>
      </div>
    </div>
  );
};

export default GapControl;
